// Registry of submission fields a research item can be cited into.
//
// Adding a new entry here makes it appear in the "Cite in field" menu on
// every research card. Existing keys (risk_summary, risk_description) are
// preserved verbatim so previously bookmarked items keep resolving to the
// same labels.
//
// `key` is the persisted citation identifier (stored in ResearchItem.cited_in
// on the backend). Don't rename existing keys — pick a new one if a label
// changes.
//
// `group` controls how the menu is sectioned. Order within a group is
// preserved.

export const CITATION_FIELDS = [
  // Program / Insured details
  { key: "insured", label: "Named Insured", group: "Program" },
  { key: "risk_summary", label: "Risk Summary", group: "Program" },
  { key: "risk_description", label: "Risk Description", group: "Program" },
  { key: "insured_address", label: "Insured Address", group: "Program" },
  { key: "industry_class", label: "Industry Class", group: "Program" },
  { key: "product_line", label: "Product Line", group: "Program" },
  { key: "naics", label: "NAICS", group: "Program" },
  { key: "broker", label: "Broker", group: "Program" },

  // Underwriting / Notes
  {
    key: "underwriting_notes",
    label: "Underwriting Notes",
    group: "Underwriting",
  },
  {
    key: "underwriter_assessment",
    label: "Underwriter Assessment",
    group: "Underwriting",
  },

  // Claims commentary
  { key: "claims_commentary", label: "Claims Commentary", group: "Claims" },

  // Exposure commentary
  {
    key: "exposure_commentary",
    label: "Exposure Commentary",
    group: "Exposure",
  },
];

export const findCitationField = (key) =>
  CITATION_FIELDS.find((f) => f.key === key);

export const groupedCitationFields = () => {
  const grouped = new Map();
  for (const field of CITATION_FIELDS) {
    if (!grouped.has(field.group)) grouped.set(field.group, []);
    grouped.get(field.group).push(field);
  }
  return Array.from(grouped.entries()).map(([group, fields]) => ({
    group,
    fields,
  }));
};
